import { useState, React, useEffect, useRef, useContext } from "react";
import Typography from "@mui/material/Typography";
import "./sidebar.scss";
import {IconButton, Tabs,Tab, Button, Link, ListSubheader } from "@mui/material";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import { styled, useTheme } from "@mui/material/styles";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import DashboardIcon from '@mui/icons-material/Dashboard';

import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import VoiceOverOffOutlinedIcon from "@mui/icons-material/VoiceOverOffOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import RemoveModeratorOutlinedIcon from "@mui/icons-material/RemoveModeratorOutlined";
import Badge from "@mui/material/Badge";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CircularProgress from '@mui/material/CircularProgress';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {triggerGtmAction} from "../../common/gtmConfiguration"
import {echoStatusLabel, callByItems} from '../../../../constants'

import UserCard from "../userCard";
import { MyContext } from "../../../pages/liveChat";
import axios from "axios";
import constants from "../../../../constants";
import { parseInstituteHash, getInfra, prepareAJAXData,maskNumber,encryptText } from "../../../../common";
import { getBaseUrl } from "../../../../environment";
import Skeleton from "@mui/material/Skeleton";
import Card from "@mui/material/Card";
import { useWebSocketContext } from "../../../pages/liveChat/webSocketConnection";
import Toast from "../toast";
import Chip from "@mui/material/Chip";
import NoSearchData from "./noSearchData";
import EchoNotConfigured from "./EchoNotConfigured";
import Collapse from '@mui/material/Collapse';
import { compileString } from "sass";
import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Dashboard } from "@mui/icons-material";
import { set } from "date-fns";

const Sidebar = (props) => {
  const [usersData, setUsersData] = useState([]);
  const [page, setPage] = useState(1);
  const [searchDot, setSearchDot] = useState(false);
  const [activeUserCard, setActiveUserCard] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [enterPressed, setEnterPressed] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [searchPlaceholder, setSearchPlaceHolder] = useState(
    "Search By Exact Name"
  );
  const [toastMessage, setToastMessage] = useState("");
  const [searchTooltip, setSearchTooltip] = useState("Name");
  const [searchTag, setSearchTag] = useState("Name");
  const [isPageChange, setIsPageChange] = useState(false);
  const [prevPageChange, setPrevPageChange] = useState(false);
  const [noSearchData, setNoSearchData] = useState(false)
  const [tabNameLoading, setTabNameLoading] = useState(true)
  const [niaaEnabled, setNiaaEnabled] = useState(0)
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [fetchConfig,setFetchConfig] = useState(false)
  const [isFetchingFilter,setIsFetchingFilter]=useState(false)
  const [onlyShowMyCreatedLeads, setOnlyShowMyCreatedLeads]=useState(0);
  const [echoReportsPermission, setEchoReportsPermission]=useState(0);
  const [newMsgRec,setNewMsgRec]=useState(false);
  // const [unread, setUnread] = useState(false);
  const [all,setAll] = useState(true)
  const [searchTooltipAction, setSearchTooltipAction] = useState(false)
  const { sendMessage, lastMessage, readyState } = useWebSocketContext();
  const [tabValue, setTabValue] = useState('0');
  const theme = useTheme();
  const {
    candidate,
    setCandidate,
    collegeId,
    instituteHash,
    collegeHash,
    fetchAgain,
    setFetchAgain,
    leadMessage,
    setLeadMessage,
    jwtToken,
    validateAuth,
    userDetails,
    errorMessageState,
    setErrorMessageState,
    tabVal,
    setTabVal,
    masking,
    setMasking,
    mobileApp,
    callBy,
    mobileView,
    setCollegeDialcode,
    collegeDialcode,
    appTheme
  } = useContext(MyContext);
  const inputRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    fetchFilterData();
    triggerGtmAction('Filter')
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
  };
  const [toggleMinIcon, setToggleMinIcon] = useState(false);
  const [toggleMinIconData,setToggleMinIconData]=useState(false);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = (event) => {
    setAnchorEl1(null);
  };



  const [value, setValue] = useState("name");
  const [session, setSession] = useState(false);
  const [LeadOwnerList, setLeadOwnerList] = useState({});
  const [counsellorList, setCounsellorList] = useState({});
  const [searchQueryCounsellor, setSearchQueryCounsellor] = useState("");
  const [sessionList, setSessionList] = useState({});
  const [ownerId, setOwnerId] = useState("");
  const [filterCount, setFilterCount] = useState(0);
  const isFetchingRef = useRef(false);
  const wasAtBottomRef = useRef(false);
  /** From live-chat-list API: `echo_enabled: false` when Echo is off; key omitted when on. */
  const [echoEnabled, setEchoEnabled] = useState(true);
  useEffect(() => {
    setEchoEnabled(true);
  }, [collegeId]);
  useEffect(()=>{
    if(mobileApp){
    props.setMobileOpen(false);
    setIsMobile(true)
    }
  },[mobileApp])
  const [openSearch, setOpenSearch] = useState(false);

  const handleOpenSearch = () => {
    setOpenSearch(!openSearch);
  };

  useEffect(async() => {
    const {infra, institute_hash} = getInfra();
    const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
    const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
    try {
      const isAuthenticated = await validateAuth();
      if (!isAuthenticated) {
        return alert("Please login to portal");
      }
      getQueryParamsFromURL();
      const post_data = prepareAJAXData({
        user_id:userDetails?.UserId,
        EntityType:userDetails?.EntityType,
          user_role:userDetails?.GroupId,
          entity_id:userDetails?.EntityId,
          url: `${meritto_service_url}/communication/v1/${collegeId}/get-enabled-bots/whatsapp`,
        });

      const botConfigresponse = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      if (botConfigresponse.data.data?.counsellor_list){
        setLeadOwnerList(botConfigresponse.data.data?.counsellor_list);
        setCounsellorList(botConfigresponse.data.data?.counsellor_list);
      }
      setNiaaEnabled(botConfigresponse.data.data?.bot_enabled)
      var maskingVal=botConfigresponse && botConfigresponse.data && botConfigresponse.data.data && botConfigresponse.data.data.masking?botConfigresponse.data.data.masking:false
      var collegeDialcodeVal=botConfigresponse && botConfigresponse.data && botConfigresponse.data.data && botConfigresponse.data.data.collegeDialcode?botConfigresponse.data.data.collegeDialcode:'+91' 
      setCollegeDialcode(collegeDialcodeVal)
      setMasking(maskingVal)
      setTabNameLoading(false)
      setOnlyShowMyCreatedLeads(botConfigresponse.data.data?.onlyShowMyCreatedLeads)
      setEchoReportsPermission(botConfigresponse.data.data?.echoReportsPermission)
      setFetchConfig(true)
    } catch (error) {
      setErrorMessageState(true);
      setToastMessage( {msg:error.message,severity:"error"});
    }

  }, []);
  const getQueryParamsFromURL = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams) {
      params[key] = value;
    }

    if(params && params.pos && params.pos == 2){
      setToggleMinIcon(true);
    }
    setToggleMinIconData(true)
    return params;
  };

  const fetchChats = async (page,echo_status ='', callFrom = "") => {
    setIsLoading(true);
    setNoSearchData(false)
    try {
      const isAuthenticated = await validateAuth();
      if (!isAuthenticated) {
        return alert("Please login to portal");
      }
      const {infra, institute_hash} = getInfra();
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      const post_data = prepareAJAXData({
          filter: {
            session: all? "" : session == "in_session" ? true : session == "not_in_session" ? false : "",
            unread: "",
            owner_id: ownerId,
          },
          search_by: value,
          search_value: searchQuery.trim(),
          page: page,
          user_id:userDetails?.UserId,
          entity_id:userDetails?.EntityId,
          user_role:userDetails?.GroupId,
          EntityType:userDetails?.EntityType,
          show_only_my_leads:onlyShowMyCreatedLeads,
          echo_status:tabVal == "0"?'':tabVal,
          url: `${meritto_service_url}/communication/v1/${collegeId}/live-chat-list`,
        });
      const response = await axios.post(
        `${meritto_node_url}/chat/${collegeHash}/getData`,
        post_data
      );
      setIsLoading(false);
      const newData = response.data.data?.listing;
      const responseData = response.data?.data ?? {};
      if ("echo_enabled" in responseData && responseData.echo_enabled === false) {
        setEchoEnabled(false);
        setUsersData([]);
        setNoSearchData(false);
        setTabNameLoading(false);
        setIsSearchLoading(false);
        return;
      }
      setEchoEnabled(true);

      setTabNameLoading(false)
      setIsSearchLoading(false)
      if(newData.length){
          if (prevPageChange !== isPageChange) {
            setUsersData((prevData) => [...prevData, ...newData]);
          } else {
            setUsersData([...newData]);
          }
      }else if (page == 1){
        setUsersData([...newData]);
        setNoSearchData(true)
      }
    } catch (error) {
      setErrorMessageState(true);
      setToastMessage( {msg:error.message,severity:"error"});
    } finally {
      isFetchingRef.current = false;
      setIsFetching(false);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);

    if (event.target.value == "email") {
      setSearchPlaceHolder("Search by Exact Email Id");
      setSearchTooltip("Email Id");
      setSearchTag("Email");
      triggerGtmAction('Email')
    } else if (event.target.value == "name") {
      setSearchPlaceHolder("Search by Exact Name");
      setSearchTooltip("Name");
      setSearchTag("Name");
      triggerGtmAction('Name')
    } else if (event.target.value == "phone") {
      setSearchPlaceHolder("Search by Exact Phone Number");
      setSearchTooltip("Phone Number");
      setSearchTag("Phone");
      triggerGtmAction('Number')
    }
    setSearchDot(true);
    inputRef.current.focus();
    setTimeout(() => {
      setSearchTooltipAction(true);
    }, 100);
  };

  const handleTooltipOpen = () => {
    setSearchTooltipAction(true);
    if(tabVal && tabVal != '0' ){
    setTabVal('0');
    }
  };

  const handleTooltipClose = () => {
    setSearchTooltipAction(false);
  };
  const [searchQuery, setSearchQuery] = useState("");
  function updateLocalStorage(generateEncryptedID){
    var opendIframe=localStorage.getItem("eoi")
    if(opendIframe){
      let newIframeIds = [];
       newIframeIds=JSON.parse(opendIframe)
      if(newIframeIds.includes(generateEncryptedID)){
       }else{
         newIframeIds.push(generateEncryptedID)
         localStorage.setItem("eoi", JSON.stringify(newIframeIds));
       }
    }else{
      opendIframe=[]
       opendIframe.push(generateEncryptedID)
       localStorage.setItem("eoi", JSON.stringify(opendIframe));
    }
  }
  const handleUserCardClick = (userData) => {
    if(callBy == callByItems.widget){
      // window.opener.yourFunc()
      var roomId=userData && userData.id?'cr_'+userData.id:'';
      var generateEncryptedID=''
      if(roomId){
        var generateEncryptedID=encryptText(roomId)
        updateLocalStorage(generateEncryptedID)
       }
       setUsersData((prevUserData) =>
        prevUserData.map((user) => {
          if (user.id === userData.id && userDetails.EntityType != "internal") {
            user.unread_msg_count = 0;
          }
          return user;
        })
      );
      let postUserData = {
        "id": userData.id,
        "mobile_no": userData.mobile_no,
        "country_dialcode": userData.country_dialcode,
        "name": userData.name,
        "m_token": userData.m_token, 
        "profile_token": userData.profile_token
      }
      const userObj = {
        NPFSSID: jwtToken,
        callBy : 'echo_widget_chat',
        userInfo:postUserData,
        iframeId:generateEncryptedID
      }
      const encryptedUserInfo=encryptText(userObj)
      const {infra, institute_hash} = getInfra();
      const meritto_livechat_url = getBaseUrl("ECHO_DOMAIN", infra);
      const postMsg=`${meritto_livechat_url}/${collegeHash}/livechat?NPFSSID=${encryptedUserInfo}`

      window.parent.postMessage(postMsg, "*");

      var applcantData = {
        msg : "applcantData",
        appId : roomId,
        appUrl: postMsg
      };
      window.parent.postMessage(applcantData, '*');


    }else{
    triggerGtmAction('Conversation open')
    setCandidate(userData);
    setUsersData((prevUserData) =>
      prevUserData.map((user) => {
        if (user.id === userData.id && userDetails.EntityType != "internal") {
          user.unread_msg_count = 0;
        }
        return user;
      })
    );
    props.setMobileOpen(false);
    setActiveIndex(userData.id);
  }
  };

  const handleCloseApplicantIframe = () => {
    window.parent.postMessage('closeApplicantIframe', '*');
  }

  const handleMinApplicantIframe = () => {
    setNewMsgRec(false)
    setToggleMinIcon(!toggleMinIcon)
    window.parent.postMessage('minApplicantIframe', '*');
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      triggerGtmAction('Search')
      setIsSearchLoading(true);
      event.preventDefault();
      setPage(() => 1);
      setPrevPageChange(() => isPageChange);
      setEnterPressed((prev) => !prev);
      handleTooltipClose()
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    const atBottom = scrollTop + clientHeight >= scrollHeight - 10 && scrollTop > 0;
    if (!atBottom) {
      wasAtBottomRef.current = false;
      return;
    }
    if (!wasAtBottomRef.current && !isFetchingRef.current) {
      wasAtBottomRef.current = true;
      isFetchingRef.current = true;
      setIsFetching(true);
      setPage((prevPage) => prevPage + 1);
      setPrevPageChange(() => isPageChange);
      setIsPageChange((prev) => !prev);
    }
  };

  const handleSessionDelete = (callFrom) => {
    if (callFrom === "session") {
      // setAll(()=>true)
      setSession(() => false);
    }
    // if (callFrom === "unread") {
    //   setUnread(() => !unread);
    // }
  };

const fetchFilterData = async () => {
     const { infra, institute_hash } = getInfra();
     setIsFetchingFilter(true);
    if (sessionList && Object.keys(sessionList).length>0){
      setIsFetchingFilter(false);
    }else{
      const meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
      const meritto_service_url = getBaseUrl("MERITTO_SERVICES", infra,"",collegeId);
      const post_data = prepareAJAXData({
          user_id:userDetails?.UserId,
          EntityType:userDetails?.EntityType,
          user_role:userDetails?.GroupId,
          entity_id:userDetails?.EntityId,
          url: `${meritto_service_url}/communication/v1/${collegeId}/get-echo-filter-data`,
          });

        const dataResponse = await axios.post(
          `${meritto_node_url}/chat/${collegeHash}/getData`,
          post_data
        );
        const filterDataList = dataResponse.data?.data;
        if (filterDataList && filterDataList.length){
          for(let filterData of filterDataList){
            if(filterData.name == 'Session' && filterData.value){
              setSessionList(filterData.value)
            }
            if(filterData.name == 'Owner' && filterData.value){
              setLeadOwnerList(filterData.value)
              setCounsellorList(filterData.value)
            }
          }
        }
      setIsFetchingFilter(false);
    }

  };
  const handleFilterCount=()=>{
    let count=0;
    if (!all && session && ownerId ){
      count=2
    }else if(session || ownerId){
      count=1
    }
    return count;
  }
  useEffect(() => {
    if(fetchConfig){
    handleTabChange(null,tabVal);
    }
  }, [tabVal,fetchConfig]);

  useEffect(() => {
    if(fetchConfig){
    if(!ownerId && !session) {
      setAll(()=>true)
    }
    setFilterCount(() => handleFilterCount());
    setIsLoading(true);
    fetchChats(page);
    }
  }, [isPageChange, session, enterPressed, all, fetchConfig, ownerId]);
  const addNewUserData = (newUserData) => {
    const existingDataIndex = usersData.findIndex(
      (userData) => userData.id === newUserData.id
    );
    if (existingDataIndex !== -1) {
      const updatedUserData = [...usersData];
      const existingUserData = updatedUserData[existingDataIndex];
      newUserData.unread_msg_count = existingUserData.unread_msg_count + 1;
      updatedUserData.splice(existingDataIndex, 1);
      setUsersData([newUserData, ...updatedUserData]);
    } else {
      newUserData.unread_msg_count = 1;
      setUsersData([newUserData, ...usersData]);
    }
  };
  useEffect(() => {
    if (!echoEnabled) return;
    if (leadMessage) {
      const updateUserData = {
        id: Number(leadMessage.room_id.split("_")[1]),
        name: leadMessage.applicant_name,
        last_reply_time: leadMessage.created_at,
        last_message: leadMessage.body,
        waba_number: leadMessage.waba_number,
        profile_token:leadMessage.profile_token,
        m_token:leadMessage.m_token,
        country_dialcode:leadMessage.country_dialcode?leadMessage.country_dialcode:collegeDialcode,
        mobile_no:masking?maskNumber(leadMessage.from):leadMessage.from
      };
      addNewUserData(updateUserData);
    }
  }, [fetchAgain, echoEnabled]);
  useEffect(() => {
    if (!echoEnabled) return;
    if (lastMessage) {
      const message = JSON.parse(lastMessage.data);
      if (message.type === "logout" && (callBy == callByItems.livechat || callBy == callByItems.widget) ) {
        localStorage.clear();
      }
      if (candidate === undefined && message.type === "lead message") {
        let newLeadMessage = message.whatsappMessage;
        if(callBy == callByItems.widget){
          let msgRoomId=newLeadMessage && newLeadMessage.room_id ? newLeadMessage.room_id:'';
          msgRoomId=encryptText(msgRoomId)
          let opendIframe=localStorage.getItem("eoi")
          opendIframe =opendIframe?JSON.parse(opendIframe):'';
          if(opendIframe && opendIframe.includes(msgRoomId)){
          } else{
            const updateUserData = {
              id: Number(newLeadMessage.room_id.split("_")[1]),
              name: newLeadMessage.applicant_name,
              last_reply_time: newLeadMessage.created_at,
              last_message: newLeadMessage.body,
              waba_number: newLeadMessage.waba_number,
              profile_token:newLeadMessage.profile_token,
              m_token:newLeadMessage.m_token,
              country_dialcode:newLeadMessage.country_dialcode?newLeadMessage.country_dialcode:collegeDialcode,
              mobile_no:masking?maskNumber(newLeadMessage.from):newLeadMessage.from,
              file_id:newLeadMessage.file_id ?newLeadMessage.file_id:0,
              file_size:newLeadMessage.file_size ?newLeadMessage.file_size:''
            };
            addNewUserData(updateUserData);
            setNewMsgRec(true);
          }
        }else{
        const updateUserData = {
          id: Number(newLeadMessage.room_id.split("_")[1]),
          name: newLeadMessage.applicant_name,
          last_reply_time: newLeadMessage.created_at,
          last_message: newLeadMessage.body,
          waba_number: newLeadMessage.waba_number,
          profile_token:newLeadMessage.profile_token,
          m_token:newLeadMessage.m_token,
          country_dialcode:newLeadMessage.country_dialcode?newLeadMessage.country_dialcode:collegeDialcode,
          mobile_no:masking?maskNumber(newLeadMessage.from):newLeadMessage.from,
          file_id:newLeadMessage.file_id ?newLeadMessage.file_id:0,
          file_size:newLeadMessage.file_size ?newLeadMessage.file_size:''
        };
        addNewUserData(updateUserData);
      }
      }
    }
  }, [lastMessage, echoEnabled]);


  function handleTabChange(event, newValue) {
    setUsersData([]);
    fetchChats(1,newValue);
    setTabValue(newValue);
    triggerGtmAction(newValue == '0'?'All':echoStatusLabel[newValue]+' Status')
  };

  const  echoBackendUrl=()=>{
       let {infra,institute_hash} = getInfra();
      if(!institute_hash){
      institute_hash=instituteHash
    }
      const meritto_backend_url = getBaseUrl("NPF_BACKEND", infra,"",institute_hash);
      return meritto_backend_url+'/backend/communications/echo'
  }
  function dashboardUrl(){
    let {infra,institute_hash} = getInfra();
    if(!institute_hash){
      institute_hash=instituteHash
    }
    const meritto_backend = getBaseUrl("NPF_BACKEND", infra,"",institute_hash);
     return `${meritto_backend}/backend/communications/echo-reports`
  }
  // const handelSearchQueryCounsellor= (event)=>{
  //   setSearchQueryCounsellor(event.target.value);
  // }

  const truncateText = (text, limit = 10) =>
  text.length > limit ? `${text.slice(0, limit)}…` : text;

  useEffect(()=>{
    if(searchQueryCounsellor.trim() !=""){
    const filteredCounsellor=Object.fromEntries(
      Object.entries(LeadOwnerList).filter(([key, value]) =>{
        if (value.toLowerCase().includes(searchQueryCounsellor.toLowerCase())){
          return [key, value]
        }
      }
      )
    );
    if(Object.keys(filteredCounsellor).length){ 
      setCounsellorList(filteredCounsellor);
    }else{
      setCounsellorList({});
    }
    }else{
      setCounsellorList(LeadOwnerList);
    }
  },[searchQueryCounsellor])
  const echoDisabled = !echoEnabled;
  return (
    <div className="sidebar">
      {errorMessageState && <Toast msg={toastMessage.msg} severity={toastMessage.severity} />}
      <aside id="sidebar-wrapper">
        <Box
          component={"div"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          width={"100%"}
          sx={{backgroundColor: theme.palette.customColor.default}}
          className={`chat-sidebar-head ${callBy == callByItems.widget? 'widget' : ''} ${callBy == callByItems.mobile ?'isApp':''} ${parseInt(appTheme) == 3 ?'dark-theme':''} ` }
          // sx={{
          //   ...(!props.mobileOpen && {
          //     justifyContent: "space-between",
          //     width: "100%",
          //   }),
          // }}
        >
          <Typography variant="h6" component="h6">
            {" "}
            
            Echo 
            {toggleMinIcon && newMsgRec && toggleMinIconData?
            <Badge size='14' color="error" className="blinkBadge errorBadge" sx={{top: '-10px'}}
            variant="dot">
            </Badge>:null}
            {!echoDisabled && !toggleMinIcon && callBy == callByItems.widget && toggleMinIconData?
            <Tooltip title="Go to Echo">
                <Link href={echoBackendUrl()} target="_blank" sx={{marginLeft: '2px', position: 'relative', top: '2px', color: "inherit"}} >
                <LaunchIcon sx={{fontSize: '1.5rem'}} /></Link>
            </Tooltip>:null}
          </Typography>

          <Typography component="div">
            {/* {!all && !toggleMinIcon && toggleMinIconData && session && <Chip
              variant="outlined"
              color={session === 'not_in_session' ? "error" : "success"}
              label={session === 'not_in_session' && !all ? "Not in Session" : "In Session"}
              size="small"
              className={session === 'not_in_session' ? "arrowTag error" : "arrowTag success"}
              sx={{borderRadius: '4px',mr:1,
                "&::after": {
                  borderLeftColor: (theme) => theme.palette.customColor.default,
                }
              }}
              onDelete={() => {
                setPage(() => 1);
                setPrevPageChange(() => isPageChange);
                handleSessionDelete("session");
              }}
            />  */}

            {/* {unread && (
              <Chip
                variant="outlined"
                color={unread === false ? "error" : "success"}
                label={unread === false ? null : "Unread"}
                size="small"
                onDelete={() => handleSessionDelete("unread")}
              />
            )} */}
          
            
              {!echoDisabled && !toggleMinIcon && toggleMinIconData ?
              <>
            <Tooltip title="Filter">
              <IconButton

                sx={{ p: "10px" }}
                onClick={handleClick}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >{!all ? <Badge
                color="primary"
                // overlap="circular"
                badgeContent={filterCount}
                // variant="dot"
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize:'1rem', minWidth: '16px', height: '16px', padding: '0 2px', top: '2px', right: '2px'
                    },
                }}
              >
                <FilterListIcon color="primary" />
              </Badge>:<FilterListIcon />}

              </IconButton>
            </Tooltip>
            {!mobileView && echoReportsPermission && callBy == callByItems.livechat ? (
            <Tooltip title="Dashboard">
              <Link href={dashboardUrl()} className="dashboard_link" target="_blanck">
                <DashboardIcon />
              </Link>
            </Tooltip>
            ) : null}

            <Tooltip title="Search">
            <IconButton className= {`searchOpen ${openSearch ? "active" : ""}`} sx={{ p: "10px" }} onClick={handleOpenSearch}>
              <SearchIcon  />
            </IconButton>
            </Tooltip>
            </>
            : "" }

            {/* <Tooltip title="Go to Echo">
              <IconButton type="button">
                <LaunchIcon />
              </IconButton>
            </Tooltip> */}
            
            {callBy == callByItems.widget && toggleMinIconData?
            <Tooltip title={toggleMinIcon ? "Maximize" : "Minimize"}>
            <IconButton type="button" onClick={handleMinApplicantIframe}>
             {toggleMinIcon ? <KeyboardArrowUpIcon sx={{fontSize: '3rem'}} /> : <KeyboardArrowDownIcon sx={{fontSize: '3rem'}}/>}
            </IconButton>
            </Tooltip>:null}

            {callBy == callByItems.widget?

            <Tooltip title="Close">
            <IconButton type="button" onClick={handleCloseApplicantIframe}>
              <CloseIcon />
            </IconButton>
            </Tooltip>:null}

          </Typography>



          {!echoDisabled && (
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            // onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                width: '160px',
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {isFetchingFilter ? 
            <>
              <ListSubheader disableSticky>  <Skeleton variant="text" width={40} height={15} /></ListSubheader>
              <MenuItem><Skeleton variant="text" width={100} /></MenuItem>
              <MenuItem> <Skeleton variant="text" width={130} /></MenuItem>
                 <Divider sx={{ my: 0.5 }} />
               <ListSubheader disableSticky>  <Skeleton variant="text" width={40} height={15} /></ListSubheader>
               <MenuItem><Skeleton variant="text" width={"100%"} height={35} /></MenuItem>
              <MenuItem><Skeleton variant="text" width={'80%'} /></MenuItem>
            </>
            :<>   
             {sessionList && Object.keys(sessionList).length > 0 &&(
              <>
              <Box component={'li'} className="filterMenuInnBlk"  sx={{borderColor: theme.palette.customColor.cardBorderColor}}>
              <ListSubheader component={'div'} color="primary" disableSticky sx={{
              fontSize: "1.1rem",
              lineHeight: '20px'
                }}>
                  Session
                </ListSubheader>
               
              {Object.entries(sessionList).map(([key, sessionValue]) => (
                <MenuItem
                  key={key}
                  component={'div'}
                  onClick={(event) => {
                    setAll(()=>false)
                    setPage(() => 1);
                    setPrevPageChange(() => isPageChange);
                    const value = event.currentTarget.getAttribute("value");
                    setSession(value);
                    // setOwnerId(()=>"")
                    setTabVal('0')
                    handleClose();
                    setSearchQueryCounsellor(()=>"")
                  }}
                  value={key}
                  selected={!all && session == key ? true : ""}
                  sx={{fontSize: '1.2rem', paddingLeft: '10px', paddingRight: '25px'}}
                >
                  {sessionValue}
                  {!all && session == key && (
                  <Tooltip title="Remove" placement="right" arrow>
                    <IconButton type="button" size="small" sx={{position: 'absolute', right: '5px'}}
                    onClick={(e)=>{
                      e.stopPropagation();
                      setPage(() => 1);
                      setPrevPageChange(() => isPageChange);
                      handleSessionDelete("session");
                      handleClose();
                    }}
                    >
                      <CloseIcon sx={{fontSize: '1rem'}} />
                    </IconButton>
                  </Tooltip>
                  )}

                </MenuItem>
              ))} 
               </Box>
              </>
             )}
             {Object.keys(LeadOwnerList).length > 0 && ( 
               <>
               
        <Box component={'li'} className="filterMenuInnBlk" sx={{borderColor: theme.palette.customColor.cardBorderColor}}>
             <ListSubheader component={'div'} color="primary" disableSticky sx={{
                  fontSize: "1.1rem",
                  lineHeight: '20px',
                }}>
              Owner
              </ListSubheader>
               <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              backgroundColor: theme.palette.customColor.default,
              boxShadow: "none",
              mt: '5px'
            }}
          >

              <SearchIcon sx={{fontSize:'1.6rem', color: '#929292', ml: '5px'}} />
              <InputBase
                sx={{ ml: 1, flex: 1, fontSize: "1.2rem" }}
                placeholder={"Search By Owner"}
                inputProps={{ "aria-label": "search Owner" }}
                 onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();  // Disables Enter
                  return;
                }
              }}
                value={searchQueryCounsellor}
                onChange={(e) => setSearchQueryCounsellor(e.target.value)}
              />
            </Paper>
              <Box style={{maxHeight: 100, overflowX: 'auto'}}>
              {counsellorList && Object.keys(counsellorList).length > 0 ?
                Object.entries(counsellorList).sort(([k1], [k2]) => {
                  if (k1 === ownerId) return -1;
                  if (k2 === ownerId) return 1;
                  return +k1 - +k2;  // optional: sort others numerically
                }).map(([key, owner]) => (
                  <MenuItem 
                  component={'div'}
                    key={key} 
                    value={key} 
                    selected={!all && ownerId == key ? true : ""}
                    sx={{ fontSize: "1.2rem", paddingLeft: '10px', paddingRight: '25px' }}
                    noWrap
                    onClick={(event) => {
                      setAll(()=>false)
                      setPage(() => 1);
                      setPrevPageChange(() => isPageChange);
                      const value = event.currentTarget.getAttribute("value");
                      setOwnerId(value);
                      // setSession(()=>false);
                      setTabVal('0')
                      handleClose();
                      setSearchQueryCounsellor(()=>"")
                    }}>
                      {
                      owner?.length > 18 ?
                     <Tooltip title={owner} placement="right"><Typography variant="inherit" noWrap>{owner}</Typography></Tooltip> :
                     <Typography variant="inherit">{owner}</Typography> 
                      }
                    {!all && ownerId === key && (
                      <Tooltip title="Remove" placement="right" arrow>
                        <IconButton
                          type="button"
                          size="small"
                          sx={{ position: "absolute", right: "5px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setPage(1);
                            setPrevPageChange(isPageChange);
                            setOwnerId("");
                            handleClose();
                          }}
                        >
                          <CloseIcon sx={{ fontSize: "1rem" }} />
                        </IconButton>
                      </Tooltip>
                    )}

                  </MenuItem>
                )):<> <Paper sx={{padding: '1rem', textAlign: 'center', fontSize: '1rem'}}><SearchOffIcon /> <div>No Data Found</div></Paper></>
    }


              </Box>
             </Box> </>)}
              
              </>}
            {/* <MenuItem
              onClick={(event) => {
                setPage(() => 1);
                setPrevPageChange(() => isPageChange);
                const value = event.currentTarget.getAttribute("value");
                setUnread(value === "true");
              }}
              value={true}
              selected={unread == false ? true : ""}
            >
              <ListItemIcon
                sx={{ color: `${unread === true ? "#4285f4" : ""}` }}
              >
                <RemoveModeratorOutlinedIcon fontSize="small" />
              </ListItemIcon>
              Unread
            </MenuItem> */}
          </Menu>
          )}
        </Box>
        {echoDisabled && (
          <div className="chat-users-list">
            <EchoNotConfigured />
          </div>
        )}
        {/* <IconButton
              onClick={props.handleDrawerClose}
              sx={{ ...(!props.mobileOpen && { display: "none" }) }}
            >
              <CloseIcon />
            </IconButton> */}
            {!echoDisabled && (
            <>
            <Collapse in={openSearch} timeout="auto" unmountOnExit>

        <Box sx={{backgroundColor: theme.palette.customColor.editorBG }} className="chat-head-search">
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              backgroundColor: theme.palette.customColor.default,
              boxShadow: "none",
            }}
          >

            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            {isSearchLoading ? <CircularProgress size={21} /> :  <SearchIcon /> }
            </IconButton>

            <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip title={`Press enter after putting your "${searchTooltip}"`}
            PopperProps={{
              disablePortal: true,
            }}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            onClose={handleTooltipClose}
            open={searchTooltipAction} >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder={searchPlaceholder}
                inputProps={{ "aria-label": "search by Exact Email Name" }}
                value={searchQuery}
                inputRef={inputRef}
                onKeyPress={handleKeyPress}
                onChange={handleSearchChange}
                onFocus={handleTooltipOpen}
                onBlur={handleTooltipClose}
              />
            </Tooltip>
            </ClickAwayListener>
            {searchQuery?
            <IconButton onClick={(event)=>{
              setSearchQuery('')
              setIsSearchLoading(true);
              event.preventDefault();
              setPage(() => 1);
              setPrevPageChange(() => isPageChange);
              setEnterPressed((prev) => !prev);}}><CloseIcon /></IconButton>:null}
            <IconButton
              onClick={handleClick1}
              aria-controls={open1 ? "search-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open1 ? "true" : undefined}
              size="small"
              aria-label= {searchTag}
              sx={{borderRadius: '5px', ml:1, bgcolor:'rgba(0, 0, 0, 0.04)'}}
              name= {searchTag}
            >
              {searchTag && (
                <Chip label={searchTag} component={'span'} size="small" sx={{bgcolor: 'transparent'}} />
              )}
              <KeyboardArrowDownIcon />
              {/* {searchDot ? (
                <Badge
                  color="primary"
                  overlap="circular"
                  badgeContent=" "
                  variant="dot"
                >
                  <KeyboardArrowDownIcon />
                </Badge>
              ) : (
                <KeyboardArrowDownIcon />
              )} */}
            </IconButton>
          </Paper>
          <Menu
            anchorEl={anchorEl1}
            id="search-menu"
            open={open1}
            onClose={handleClose1}
            onClick={handleClose1}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <FormLabel
              component={"div"}
              id="demo-radio-buttons-group-label"
              sx={{
                pl: "2rem",
                fontSize: "1.2rem",
                fontWeight: 500,
                pb: "1rem",
                pt: "1rem",
              }}
            >
              Choose your prefrence to search
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              <ListItemButton role={undefined} dense tabIndex={1}>
                <FormControlLabel
                  sx={{ alignItems: "start", mr: 0, width: "100%" }}
                  value="email"
                  tabIndex={1}
                  control={<Radio size="small" sx={{ pt: "2px" }} tabIndex={1} />}
                  label={
                    <div>
                      <div>Email Id</div>
                      <div
                        style={{
                          fontSize: "0.8em",
                          color: "gray",
                          marginTop: "-3px",
                        }}
                      >
                        Perform search based on Email id
                      </div>
                    </div>
                  }
                />
              </ListItemButton>
              <ListItemButton role={undefined} dense tabIndex={2}>
                <FormControlLabel
                  sx={{ alignItems: "start", mr: 0, width: "100%" }}
                  value="name"
                  tabIndex={2}
                  control={<Radio size="small" sx={{ pt: "2px" }} tabIndex={2} />}
                  label={
                    <div>
                      <div>Name</div>
                      <div
                        style={{
                          fontSize: "0.8em",
                          color: "gray",
                          marginTop: "-3px",
                        }}
                      >
                        Perform search based on User Name
                      </div>
                    </div>
                  }
                />
              </ListItemButton>
              <ListItemButton role={undefined} dense tabIndex={3}>
                <FormControlLabel
                  sx={{ alignItems: "start", mr: 0, width: "100%" }}
                  value="phone"
                  tabIndex={3}
                  control={<Radio size="small" sx={{ pt: "2px" }} tabIndex={3} />}
                  label={
                    <div>
                      <div>Phone Number</div>
                      <div
                        style={{
                          fontSize: "0.8em",
                          color: "gray",
                          marginTop: "-3px",
                        }}
                      >
                        Perform search based on Phone Number
                      </div>
                    </div>
                  }
                />
              </ListItemButton>
            </RadioGroup>
          </Menu>
        </Box>
        </Collapse>



        <Divider />
        <Box>
          {tabNameLoading?null:
        <Tabs
        className="echo-tabs"
          sx={{minHeight: "30px",  
            borderColor: theme.palette.customColor.cardBorderColor,
            "& .MuiTab-root.Mui-selected": {
              color: theme.palette.customColor.blueColor
            },
            "& .MuiTabs-indicator": {
              backgroundColor: theme.palette.customColor.blueColor, // Change indicator color
            },
          }}
          value={tabValue ? tabValue:'0'}
          onChange={(e,value)=>{
            triggerGtmAction(value == '0'?'All':echoStatusLabel[value]+' Status')
            setTabVal(value);
          }}
          // textColor="secondary"
          // indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
        <Tab value="0" className="eTab" label="All" />
        <Tab value="1" className="eTab" label="Niaa" />
        <Tab value="2" className="eTab" label="Queued" />
        <Tab value="3" className="eTab" label="Picked" />
        </Tabs>
}
        </Box>
        <div className={`chat-users-list ${openSearch ? "searchActive" : ""}`} onScroll={handleScroll}>
          {tabVal == "1"  && !niaaEnabled?'':
          <>{usersData.map((userData, index) => (
            <UserCard
              key={userData.id}
              {...userData}
              func={() => handleUserCardClick({ ...userData })}
              variant="none"
              isActive={activeIndex === userData.id}
            />
          ) )}</>}
          {(noSearchData && ( tabVal == "1" &&  niaaEnabled )) || (noSearchData && tabVal !='1') ? <NoSearchData /> : ""}
          {!isLoading && tabVal == "1" &&  !niaaEnabled  ?
          <Typography className="noData-search-blk" component={'div'}>
            <Typography component={'div'}>
                <Typography component={'div'} style={{padding:"0px 20px"}} className="no-data-msg">
                If you don’t already know, Niaa is our education chatbot, built to automatically engage inbound student traffic and answer queries 24/7. It frees up your sales and counseling teams from repetitive tasks, letting them step in when students need them most.
                Click here to learn more about Niaa and how to get started. <br /><br />
                 <a href="https://pages.meritto.com/lp/niaa-echo.html?source=product" onChange={(e,value)=>{
            triggerGtmAction(value == '0'?'All':'NIAA Lead Generation on Echo')
            setTabVal(value);
          }} target="_blanck">Click here</a> if you’re looking to know more about Niaa and understand how you can get started with it.
         </Typography>
            </Typography>
        </Typography> :''}
          {isLoading && (
            <>
              <Card
                sx={{
                  minWidth: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "16px",
                }}
                variant="none"
              >
                <Typography component={"div"} sx={{ display: "flex" }}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Typography component={"div"} px={1} width={200}>
                    <Skeleton variant="text" width={"100%"} />
                    <Skeleton variant="text" width={"100%"} />
                  </Typography>
                </Typography>

                <Typography component={"div"}>
                  <Skeleton variant="text" width={"50px"} />
                  <Skeleton variant="circular" width={"20px"} height={"20px"} />
                </Typography>
              </Card>
              <Divider />
            </>
          )}


        </div>
            </>
            )}
      </aside>
    </div>
  );
};

export default Sidebar;